<template>
    <div class="mb-5 sidebarlistcard">
        <Skeleton height=".5rem" width="35%" class="mb-1"></Skeleton>
        <Skeleton height="0.5rem" width="70%" class="mb-2"></Skeleton>
        <Skeleton width="90%" height="0.5rem"></Skeleton>
        <Skeleton width="90%" height="0.5rem"></Skeleton>
        <Skeleton width="90%" height="0.5rem"></Skeleton>

        <Skeleton width="100%" height="1rem" class="mt-3" v-if="carddescription"></Skeleton>
    </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
props:{
    carddescription:{
        type:Boolean,
        default:false,
    }
}
})
</script>

<style>
.sidebarlistcard{
    background-color: #FFFFFF;
    padding: 10px;
    border:1px solid #e1e1e1;
    border-radius: 5px;
    margin: 10px 5px;
}
</style>